import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Modal as AModal, Col, message, Popover, Row, Tooltip } from 'antd';
import React, { Fragment } from 'react';
import { ExpandIcon, Label, MoneyDiscountValue, MoneyLabel, MoneyRow, MoneyValue, NoteIcon } from './styledComponents';

import messages from 'containers/OrdersPage/messages';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import media from 'utils/mediaStyle';
import { getPermissionsActive } from 'utils/permissionMap';
import Button from '../Button/Button';
import Money from '../Money/Money';
import OrderStatus from '../OrderStatus';
import Notes from './Notes.svg';

import { Icon } from '@ant-design/compatible';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import { selectVaInfo } from 'containers/MainLayout/selectors';
import { RootState } from 'containers/OrderDetailsPage/types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import translations from 'translations';
import { Order, OrderStatus as OrderStatusEnum, OrderType } from 'types/schema';
import { convertTimestamp } from 'utils/dateTimeUtils';
import utilsMessages from 'utils/messages';
import VatTooltip from '../VatTooltip';
import CopyIcon from './Copy.svg';
import Info from './Info.svg';
import KamereoBankQr from './kamereoBankQr.png';

export const Container = styled.div`
  .ant-col {
    width: 100% !important;
  }
`;
export const InfoRow = styled.div`
  margin-bottom: 4pt;
  display: flex;
  flex-direction: row;
`;

const TotalLabel = styled.span`
  margin-top: 4px;
  margin-bottom: 2px;
  color: #1d1e20;
  font-size: 14px;
  font-weight: 600;
`;

const LabelBtn = styled.span`
  color: #f5222d;
  min-width: 80pt;
  cursor: pointer;
  text-align: right;
  margin-left: auto;
`;
const SupplierName = styled.h3``;

const Value = styled.span`
  color: ${({ color }) => (color ? color : 'rgba(0, 0, 0, 0.87)')};
  flex: 1;
  > * {
    display: inline-block;
  }
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: center;
  flex: 1;
  margin-top: 10px;
  ${Button} {
    margin-bottom: 8pt;
    width: 100%;
    ${media.md`
      width: auto;
      margin-left: 8pt;
    `};
  }
`;

const ReDeliveryOrder = styled.span`
  min-width: 80pt;
  margin-bottom: 10px;
  font-size: 12px;
`;

const DeliveryPolicy = styled(Row)`
  margin-left: -8pt;
  margin-right: -8pt;
  .ant-divider {
    margin-top: 6px;
    margin-bottom: 8pt;
  }
  span {
    margin: 0 8pt;
    white-space: pre-line;
  }
`;

const TransferInstruction = styled.div`
  ${({ marginTop }) => marginTop && `margin-top: ${marginTop}; width: 100% !important`}
  position: relative;
  display: flex;
  gap: 4px;
  align-items: flex-start;
  background: #fffbeb;
  border-radius: 8px;
  padding: 10px 8px;
  margin-bottom: 6px;
`;

const TransferInstructionTextbox = styled.div`
  font-size: 14px;
  color: #242527;
`;
const TransferInstructiontNoteText = styled.div`
  color: #43a047;
  cursor: pointer;
`;

const Modal = styled(AModal)`
  max-width: 536px !important;
  width: 100% !important;
  padding: 0 16px;
  .ant-modal-footer {
    display: none;
  }
`;

const TransferInstructionTitle = styled.div`
  text-align: center;
`;
const QrWrapper = styled.div`
  flex-shrink: 0;
  width: 144px;
  background: #f6f6f6;
  border-radius: 8px;
  padding: 10px;
`;
const QrTitle = styled.div`
  font-size: 14px;
  color: #808289;
  text-align: center;
`;
const QrImage = styled.img`
  width: 124px;
  height: 124px;
  margin-top: 4px;
`;
const AccountInfoWrapper = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 16px;
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: center;
  }
`;
const AccountInfoTextBox = styled.div`
  width: 100%;
`;
const AccountInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  &:not(:last-child) {
    margin-bottom: 7px;
  }
`;
const AccountInfoTextWrapper = styled.div``;
const AccountInfoLabel = styled.div`
  color: #808289;
  font-size: 14px;
`;
const AccountInfoContent = styled.div`
  color: #242527;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin-top: 4px;
`;
const SeparateLine = styled.div`
  margin: 24px 0;
  height: 1px;
  width: 100%;
  background: #d9d9d9;
`;
const ImportantNoteTitle = styled.div`
  color: #242527;
  font-size: 14px;
  font-weight: 600;
`;
const ImportantNoteText = styled.div`
  color: #242527;
  font-size: 14px;
  font-weight: 400;
`;

const Copy = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;
const CopyText = styled.div`
  color: #43a047;
  font-size: 14px;
`;

interface IStateProps {
  vaInfo: any;
}

interface OrderSummaryProps extends IStateProps {
  isMobileSize: boolean;
  order: Order;
  onCancelOrder: () => void;
  reOrderAll: () => void;
  onApproveOrder: () => void;
  onDisapproveOrder: () => void;
  onEditOrder: () => void;
  onUpdateDelivery: (data: any) => void;
  onPrintOrderInvoice: (data: string) => void;
  permissions: string[];
}

const componentPermissions = {
  addItemToCart: 'ORDER_PLACE',
  editPriceOrder: 'ORDER_ITEM_SET_PRICE',
  editQuantityOrder: 'ORDER_ITEM_SET_QUANTITY',
  confirmDeliveryOrder: 'ORDER_DELIVERY_CONFIRM',
  cancelOrder: 'ORDER_CANCEL',
};

const CopyElement = (text) => {
  const copy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        message.success(translations(messages.copySuccess));
      })
      .catch(() => {
        message.error(translations(messages.copyFail));
      });
  };
  return (
    <Copy onClick={() => copy(text)}>
      <SVGIcon src={CopyIcon} />
      <CopyText>
        <FormattedMessage {...messages.copy} />
      </CopyText>
    </Copy>
  );
};

class LegacyOrderSummary extends React.Component<OrderSummaryProps> {
  public state = { expandOrder: false, isShowTransferPopup: false };

  public onExpandOrder = () => {
    if (this.props.isMobileSize) {
      this.setState({ expandOrder: !this.state.expandOrder });
    }
  };

  public orderType = (orderType) => {
    switch (orderType) {
      case OrderType.Gift:
        return translations(messages.giftOrder);
      case OrderType.Sample:
        return translations(messages.sampleOrder);
      case OrderType.Redelivery:
        return translations(messages.redeliveryOrder);
      case OrderType.Employee:
        return translations(messages.employeeOrder);
      default:
        return '';
    }
  };

  public orderForDependOnOrderType = (order: any) => {
    switch (order?.orderType) {
      case OrderType.Employee:
      case OrderType.Gift:
      case OrderType.Sample:
        return order?.zeroOrderInfo.receiver;
      case OrderType.Redelivery:
        return order?.zeroOrderInfo.orderId;
      case OrderType.PaidOrder:
        return '';
      default:
        return 'Chưa xác định được';
    }
  };

  public render() {
    const { order, permissions, onApproveOrder, onEditOrder, onDisapproveOrder, onPrintOrderInvoice, vaInfo } =
      this.props;
    const orderDate = moment(order?.orderDate);
    const printShouldBeReady: boolean = orderDate.isBefore(moment().subtract(1, 'minutes'));
    const isExpandOrder = this.props.isMobileSize ? this.state.expandOrder : true;
    const canApproveOrder = getPermissionsActive(['ORDER_APPROVE'], permissions);
    const bankAccount = {
      accountName: vaInfo?.vaName || 'CÔNG TY TNHH KAMEREO',
      accountNumber: vaInfo.vaAccountNumber || '137483',
      bank: 'NGÂN HÀNG PHƯƠNG ĐÔNG (OCB) - CN TP.HCM',
      qrCode: vaInfo?.qrDataBase64 || KamereoBankQr,
    };
    const transferNotes = [
      <FormattedMessage key="1" {...messages.firstImportantNote} />,
      <FormattedMessage key="2" {...messages.thirdImportantNote} />,
    ];
    return (
      <Container>
        <Row gutter={8} style={{ marginBottom: '10pt' }} onClick={this.onExpandOrder}>
          <Col span={24}>
            <InfoRow style={{ width: '100%', justifyContent: 'space-between' }}>
              {/* <Link to={`/suppliers/${encodeURIComponent(order?.supplier?.name)}`}> */}
              <SupplierName>{order?.supplier?.name}</SupplierName>
              {/* </Link> */}
              {/* {this.props.isMobileSize
                ? null
                : order &&
                  order?.status !== 'PENDING_APPROVAL' && (
                    <Button
                      type="primary"
                      ghost
                      onClick={() => onPrintOrderInvoice(order?.id)}
                      disabled={!printShouldBeReady}
                      loading={this.props.order?.printOrderLoading}
                    >
                      <PrinterOutlined /> <FormattedMessage {...utilsMessages.print} />
                    </Button>
                  )} */}
            </InfoRow>
            <InfoRow>
              <OrderStatus status={order?.status} statusText={order?.statusText} />
            </InfoRow>
            {this.props.isMobileSize && (
              <ExpandIcon>{this.state.expandOrder ? <UpOutlined /> : <DownOutlined />}</ExpandIcon>
            )}
          </Col>
        </Row>
        <Row gutter={8}>
          {isExpandOrder && (
            <Fragment>
              <Col lg={9} sm={24}>
                <InfoRow>
                  <Label>
                    <FormattedMessage {...utilsMessages.orderId} />
                  </Label>
                  <Value style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{order?.id}</Value>
                </InfoRow>
                <InfoRow>
                  <Label>
                    <FormattedMessage {...messages.orderTime} />
                  </Label>
                  <Value>{moment(order?.orderDate).format('HH:mm DD/MM/YYYY')}</Value>
                </InfoRow>
                {order?.orderType !== OrderType.PaidOrder && (
                  <InfoRow>
                    <Label>
                      <FormattedMessage {...messages.orderType} />
                    </Label>
                    <Col>
                      <Row>
                        <p style={{ marginRight: 10 }}>{this.orderType(order?.orderType)}</p>
                        {order?.zeroOrderInfo?.reason && (
                          <Tooltip title={order?.zeroOrderInfo?.reason} placement="topLeft" style={{ marginLeft: 20 }}>
                            <Icon type="exclamation-circle" />
                          </Tooltip>
                        )}
                      </Row>
                      <p>{this.orderForDependOnOrderType(order)}</p>
                    </Col>
                  </InfoRow>
                )}
                <InfoRow>
                  <Label>
                    <FormattedMessage {...messages.deliveryTime} />
                  </Label>
                  <Value>
                    {moment(order?.deliveryTime?.start).format('HH:mm')}-
                    {moment(order?.deliveryTime?.end).format('HH:mm')}{' '}
                    {moment(order?.deliveryTime?.end).format('DD/MM/YYYY')}
                  </Value>
                </InfoRow>
                <InfoRow>
                  <Label>
                    <FormattedMessage {...messages.creator} />
                  </Label>
                  <Value>{order?.creator?.name}</Value>
                </InfoRow>
                <InfoRow>
                  <Label>
                    <FormattedMessage {...messages.storeName} />
                  </Label>
                  <Value>{order?.store?.name}</Value>
                </InfoRow>
                {order?.cancelledAudit?.userName && (
                  <InfoRow>
                    <Label>
                      <FormattedMessage {...messages.cancelPerson} />
                    </Label>
                    <Value>{order?.cancelledAudit?.userName}</Value>
                  </InfoRow>
                )}
                {order?.cancelledAudit?.time && (
                  <InfoRow>
                    <Label>
                      <FormattedMessage {...messages.cancelTime} />
                    </Label>
                    <Value>{convertTimestamp(order?.cancelledAudit?.time)}</Value>
                  </InfoRow>
                )}
              </Col>
              <Col lg={8} sm={24}>
                <InfoRow>
                  <Label>
                    <FormattedMessage {...utilsMessages.paymentMethod} />
                  </Label>
                  <Value>
                    <FormattedMessage {...utilsMessages[order?.paymentMethod || 'COD']} />
                  </Value>
                </InfoRow>
                <InfoRow>
                  <Label>
                    <FormattedMessage {...messages.totalItems} />
                  </Label>
                  <Value>{order?.items.length}</Value>
                </InfoRow>
                <InfoRow>
                  <Label>
                    <FormattedMessage {...messages.notes} />
                  </Label>
                  <Value>
                    {order?.note ? (
                      <Popover content={<pre>{order?.note}</pre>}>
                        <NoteIcon src={Notes} note="true" />
                      </Popover>
                    ) : (
                      <NoteIcon src={Notes} />
                    )}
                  </Value>
                </InfoRow>
                {(order?.status === 'ACCEPTED' ||
                  order?.status === 'PENDING_DELIVERY' ||
                  order?.status === 'DELIVERING') && (
                  <TransferInstruction>
                    <SVGIcon src={Info} style={{ marginTop: '3px' }} />
                    <TransferInstructionTextbox>
                      <div>
                        <FormattedMessage {...messages.transferNote} />
                      </div>
                      <TransferInstructiontNoteText
                        onClick={() => {
                          this.setState({
                            ...this.state,
                            isShowTransferPopup: !this.state.isShowTransferPopup,
                          });
                        }}
                      >
                        <FormattedMessage {...messages.transferInstruction} />
                      </TransferInstructiontNoteText>
                    </TransferInstructionTextbox>
                  </TransferInstruction>
                )}
                {order?.status === 'DECLINED' ? (
                  <InfoRow>
                    <Label>
                      <FormattedMessage {...messages.declineReason} />
                    </Label>
                    <Value>{order?.declineReason}</Value>
                  </InfoRow>
                ) : null}
              </Col>
            </Fragment>
          )}
          <Col lg={7} sm={24}>
            <MoneyRow>
              <MoneyLabel>
                <FormattedMessage {...messages.subTotal} />
              </MoneyLabel>
              <MoneyValue>
                <Money>{order?.subTotalBeforeVat}</Money>
              </MoneyValue>
            </MoneyRow>
            <MoneyRow>
              <MoneyLabel>
                <FormattedMessage {...utilsMessages.serviceFee} />
              </MoneyLabel>
              <MoneyValue>
                <Money>{order?.deliveryFee?.fee || 0}</Money>
              </MoneyValue>
            </MoneyRow>
            {!!order?.deliveryFee?.discount && (
              <MoneyRow>
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.freeServiceFee} />
                </MoneyLabel>
                <MoneyDiscountValue>
                  -<Money>{order?.deliveryFee?.discount}</Money>
                </MoneyDiscountValue>
              </MoneyRow>
            )}
            <MoneyRow>
              <div style={{ display: 'flex', gap: '4px', color: 'rgba(0, 0, 0, 0.54)' }}>
                VAT
                <VatTooltip
                  productVat={order.totalVatOnProducts || 0}
                  serviceFeeVat={!order?.deliveryFee?.discount ? (order?.deliveryFee?.additionalVat as number) : 0}
                />
              </div>
              <MoneyValue>
                <Money>{order?.totalVat || 0}</Money>
              </MoneyValue>
            </MoneyRow>
            {!!order?.discount && (
              <MoneyRow>
                <MoneyLabel>
                  <FormattedMessage {...utilsMessages.promotion} />
                </MoneyLabel>
                <MoneyDiscountValue>
                  -<Money>{order?.discount}</Money>
                </MoneyDiscountValue>
              </MoneyRow>
            )}
            <MoneyRow>
              <TotalLabel>
                <FormattedMessage {...messages.total} />
              </TotalLabel>
              <TotalLabel>
                <Money>{order?.total}</Money>
              </TotalLabel>
            </MoneyRow>
            {order?.orderType !== OrderType.PaidOrder && (
              <Row justify="end">
                <ReDeliveryOrder>{`(${this.orderType(order?.orderType)})`}</ReDeliveryOrder>
              </Row>
            )}
            {order?.status !== 'PENDING_APPROVAL' && (
              <>
                <InfoRow>
                  {permissions.includes(componentPermissions.cancelOrder) &&
                    order?.status &&
                    order?.status === OrderStatusEnum.Sent && (
                      <LabelBtn onClick={this.props.onCancelOrder}>
                        <FormattedMessage {...messages.cancelOrder} />
                      </LabelBtn>
                    )}
                </InfoRow>
                <Actions>
                  {permissions.includes(componentPermissions.addItemToCart) && (
                    <Button type="primary" ghost onClick={this.props.reOrderAll}>
                      <FormattedMessage {...utilsMessages.addAll} />
                    </Button>
                  )}
                </Actions>
              </>
            )}
            {order?.status === 'PENDING_APPROVAL' && canApproveOrder && (
              <div style={{ textAlign: 'right' }}>
                <Button
                  size="small"
                  type="danger"
                  ghost
                  style={{ borderColor: 'transparent', paddingLeft: 0, paddingRight: 0 }}
                  onClick={onDisapproveOrder}
                >
                  <FormattedMessage {...messages.declineThisOrder} />
                </Button>
                <Actions>
                  <Tooltip title={!!order?.discount ? translations(messages.editableOrderTooltip) : ''}>
                    <Button type="primary" ghost onClick={onEditOrder} disabled={!!order?.discount}>
                      <FormattedMessage {...utilsMessages.edit} />
                    </Button>
                  </Tooltip>
                  <Button type="primary" onClick={onApproveOrder}>
                    <FormattedMessage {...utilsMessages.approve} />
                  </Button>
                </Actions>
              </div>
            )}
          </Col>
        </Row>

        <Modal
          open={this.state.isShowTransferPopup}
          closeIcon={true}
          centered={true}
          destroyOnClose={true}
          maskClosable={true}
          onCancel={() => {
            this.setState({
              ...this.state,
              isShowTransferPopup: !this.state.isShowTransferPopup,
            });
          }}
        >
          <TransferInstructionTitle>{translations(messages.transferInstructions)}</TransferInstructionTitle>
          <AccountInfoWrapper>
            {vaInfo.vaAccountNumber ? (
              !!vaInfo?.qrDataBase64 && (
                <QrWrapper>
                  <QrTitle>
                    <FormattedMessage {...messages.qrCode} />
                  </QrTitle>
                  <QrImage src={bankAccount.qrCode} />
                </QrWrapper>
              )
            ) : (
              <QrWrapper>
                <QrTitle>
                  <FormattedMessage {...messages.qrCode} />
                </QrTitle>
                <QrImage src={bankAccount.qrCode} />
              </QrWrapper>
            )}
            <AccountInfoTextBox>
              <AccountInfoRow>
                <AccountInfoTextWrapper>
                  <AccountInfoLabel>
                    <FormattedMessage {...messages.accountName} />
                  </AccountInfoLabel>
                  <AccountInfoContent>{bankAccount.accountName}</AccountInfoContent>
                </AccountInfoTextWrapper>
              </AccountInfoRow>
              <AccountInfoRow>
                <AccountInfoTextWrapper>
                  <AccountInfoLabel>
                    <FormattedMessage {...messages.accountNumber} />
                  </AccountInfoLabel>
                  <AccountInfoContent>{bankAccount.accountNumber}</AccountInfoContent>
                </AccountInfoTextWrapper>
                {CopyElement(bankAccount.accountNumber)}
              </AccountInfoRow>
              <AccountInfoRow>
                <AccountInfoTextWrapper>
                  <AccountInfoLabel>
                    <FormattedMessage {...messages.bank} />
                  </AccountInfoLabel>
                  <AccountInfoContent>{bankAccount.bank}</AccountInfoContent>
                </AccountInfoTextWrapper>
              </AccountInfoRow>
            </AccountInfoTextBox>
          </AccountInfoWrapper>
          <SeparateLine />
          <AccountInfoRow>
            <AccountInfoTextWrapper>
              <AccountInfoLabel>
                <FormattedMessage {...messages.totalAmount} />
              </AccountInfoLabel>
              <AccountInfoContent>
                <Money>{order?.total}</Money>
              </AccountInfoContent>
            </AccountInfoTextWrapper>
            {CopyElement(order?.total)}
          </AccountInfoRow>
          <AccountInfoRow>
            <AccountInfoTextWrapper>
              <AccountInfoLabel>
                <FormattedMessage {...messages.tranferMessage} />
              </AccountInfoLabel>
              <AccountInfoContent>{order?.id}</AccountInfoContent>
            </AccountInfoTextWrapper>
            {CopyElement(order?.id)}
          </AccountInfoRow>
          <TransferInstruction marginTop="14px">
            <SVGIcon src={Info} style={{ marginTop: '3px' }} />
            <TransferInstructionTextbox>
              <ImportantNoteTitle>
                <FormattedMessage {...messages.importantNotes} />
              </ImportantNoteTitle>
              {transferNotes.map((note, idx) => (
                <ImportantNoteText key={idx}>
                  {`${idx + 1}. `}
                  {note}
                </ImportantNoteText>
              ))}
              {transferNotes.map((note, idx) => (
                <ImportantNoteText key={idx}>
                  {`${idx + 1}. `}
                  {note}
                </ImportantNoteText>
              ))}
            </TransferInstructionTextbox>
          </TransferInstruction>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector<RootState, IStateProps>({
  vaInfo: selectVaInfo(),
});

export default connect(mapStateToProps)(LegacyOrderSummary);
